import { dotSceneNameMap } from '@ali/dsfe-dot-element-react';

const newDotSceneNameMap = {
  ...dotSceneNameMap,
  importList: {
    ...dotSceneNameMap.importList,
    samplePrductCard: 'importlist_samplePrductCard',
  },
  deliveryManagement: {
    list: 'deliveryManagementList',
    card: 'deliveryManagementOrderCard',
    upload: 'upload',
  },
  productOptimizer: {
    hasBindStoreList: 'productOptimizer_hasBindStoreList',
    noBindStoreList: 'productOptimizer_noBindStoreList',
    addStore: 'productOptimizer_addStore',
  },
};

export default newDotSceneNameMap;
